// extracted by mini-css-extract-plugin
export default {"listTasks":"List_listTasks__dZq1y"};